const DOCUPLOAD_SYSTEM_ERROR = "Docupload:System Error";
const DOCUPLOAD_UPLOAD_FAILURE = "Docupload:Upload Failure";
const DOCUPLOAD_SUBMISSION_ERROR = "Docupload:Submission Error";
const DOCUPLOAD_FILE_SIZE_ERROR = "Docupload:File Size Error";
const YODLEE_FG_MATCH_ERROR = "Yodlee:TPDG API Failure";
const YODLEE_FG_NAME_MATCH_ERROR = "Yodlee:TPDG API Failure:003:Name Match Criteria";
const YODLEE_FG_FEW_TRANSACTIONS_ERROR = "Yodlee:TPDG API Failure:004:Not Enough Transactions";
const YODLEE_FG_TRANSACTION_HISTORY_ERROR = "Yodlee:TPDG API Failure:005:No Trx Greater Than 30d";
const YODLEE_FG_ACCOUNT_SUPPORT_ERROR = "Yodlee:TPDG API Failure:006:Non Supported Account Type";
const YODLEE_FG_BETA_SITE_ERROR = "Yodlee:TPDG API Failure:007:Beta Site";
const YODLEE_FG_PARTIAL_DATA_ERROR = "Yodlee:TPDG API Failure 008:Partial Data";
const YODLEE_FG_NO_DATA_ERROR = "Yodlee:TPDG API Failure 009: No Data";
const YODLEE_FG_ACCOUNT_INFO_ERROR = "TPDG API Failure 010: Acc Or Routing No Is NA Or Incorrect";

const errorTagMap = {
  "error.default.message": "Default Error",
  "error.dialog.icon": "Icon Warning",
  "error.service.message": "Service Error",
  "Docupload.failed.message": DOCUPLOAD_UPLOAD_FAILURE,
  "error.50100.message": DOCUPLOAD_SYSTEM_ERROR,
  "error.50110.message": DOCUPLOAD_SYSTEM_ERROR,
  "error.50130.message": "Docupload:Corrupt File Error",
  "error.50200.message": DOCUPLOAD_SYSTEM_ERROR,
  "error.50210.message": DOCUPLOAD_SYSTEM_ERROR,
  "error.50220.message": DOCUPLOAD_SYSTEM_ERROR,
  "error.50260.message": DOCUPLOAD_SUBMISSION_ERROR,
  "error.50270.message": DOCUPLOAD_SUBMISSION_ERROR,
  "error.50280.message": DOCUPLOAD_SYSTEM_ERROR,
  "error.50300.message": DOCUPLOAD_FILE_SIZE_ERROR,
  "error.50310.message": "Docupload:File Format Error",
  "error.50320.message": DOCUPLOAD_FILE_SIZE_ERROR,
  "error.50360.message": DOCUPLOAD_SUBMISSION_ERROR,
  "error.60200.message": DOCUPLOAD_UPLOAD_FAILURE,
  "error.60210.message": DOCUPLOAD_UPLOAD_FAILURE,
  "error.60220.message": DOCUPLOAD_UPLOAD_FAILURE,
  "error.60240.message": DOCUPLOAD_UPLOAD_FAILURE,
  "error.duplicate.message": "Docupload:Same File Name Error",
  "error.fileName.message": "Docupload:File Name Size Error",
  "DocuSign.failed.message": "DocuSign:DocuSign Failed Error",
  "error.901.message": "LinkedIn:Invalid State Token Error",
  "error.911.message": "LinkedIn:Invalid Request Parameters Error",
  "error.921.message": "LinkedIn:User Cancellation Error",
  "error.931.message": "LinkedIn:Profile Id Error",
  "error.951.message": "LinkedIn:Gateway Internal Error",
  "LinkedIn.failed.message": "LinkedIn:Verification Failure",
  "LinkedIn.unavailable.message": "LinkedIn:LinkedIn Unavailable",
  "error.FG_failed.message": "Yodlee:FG Failure Error",
  "Yodlee.failed.message": "Yodlee:Yodlee failure",
  "yodlee.fg.match.error": YODLEE_FG_MATCH_ERROR,
  "yodlee.fg.match.error.001": YODLEE_FG_MATCH_ERROR,
  "yodlee.fg.match.error.002": YODLEE_FG_MATCH_ERROR,
  "yodlee.fg.match.error.003": YODLEE_FG_NAME_MATCH_ERROR,
  "yodlee.fg.match.error.004": YODLEE_FG_FEW_TRANSACTIONS_ERROR,
  "yodlee.fg.match.error.005": YODLEE_FG_TRANSACTION_HISTORY_ERROR,
  "yodlee.fg.match.error.006": YODLEE_FG_ACCOUNT_SUPPORT_ERROR,
  "yodlee.fg.match.error.007": YODLEE_FG_BETA_SITE_ERROR,
  "yodlee.fg.match.error.008": YODLEE_FG_PARTIAL_DATA_ERROR,
  "yodlee.fg.match.error.009": YODLEE_FG_NO_DATA_ERROR ,
  "yodlee.fg.match.error.010": YODLEE_FG_ACCOUNT_INFO_ERROR,
  "yodlee.fg.match.error.all.attempts": "Yodlee:FG All Attempts Failure",
  "nova.UNSUPPORTED_COUNTRY": "Nova:Unsupported Country",
  "nova.REQUEST_TIMEOUT": "Nova:Request Timeout",
  "nova.BUREAU_UNRESPONSIVE": "Nova:Bureau Unresponsive",
  "nova.UNKNOWN_CUSTOMER": "Nova:Unknown Customer",
  "nova.INVALID_PRODUCT": "Nova:Invalid Product",
  "nova.INTERNAL_ERROR": "Nova:Internal Error",
  "nova.SCRIPT": "Nova:Script load failed"
}

export const mapErrorKeyToErrorTag = (errorKey) => {
  return errorTagMap[errorKey] ||
    errorTagMap['error.default.message'];
}



// WEBPACK FOOTER //
// ./application/src/utilities/errorTagging.js